import "../assets/index-3764a447.css";
import { vOnClickOutside as n } from "@vueuse/components";
import { createFocusTrap as o } from "focus-trap";
import { G as s } from "../chunks/GenRandomId-cb9ccebe.mjs";
import a from "../Mixins/clickOutsideOptions.mjs";
import "../Composables/useIsFullscreen.mjs";
import "../Composables/useIsMobile.mjs";
import "@nextcloud/router";
/* empty css                                                                                   */import { n as d } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
import "linkify-string";
import "escape-html";
import "striptags";
import "vue";
import "@nextcloud/auth";
import "@nextcloud/axios";
import "@nextcloud/capabilities";
import { g as c } from "../chunks/focusTrap-5d0f71d4.mjs";
const p = {
  name: "NcHeaderMenu",
  directives: {
    ClickOutside: n
  },
  mixins: [
    a
  ],
  props: {
    /**
     * Unique id for this menu
     */
    id: {
      type: String,
      required: !0
    },
    /**
     * aria-label attribute of the menu open button
     */
    ariaLabel: {
      type: String,
      default: ""
    },
    /**
     * Current menu open state
     */
    open: {
      type: Boolean,
      default: !1
    },
    /**
     * Pass `true` if the header menu is used for website navigation
     *
     * The wrapper tag will be set to `nav` and its `aria-labelledby`
     * will be associated with the menu open button
     */
    isNav: {
      type: Boolean,
      default: !1
    },
    /**
     * Additional visually hidden description text for the menu
     * open button
     */
    description: {
      type: String,
      default: null
    }
  },
  emits: [
    "close",
    "closed",
    "open",
    "opened",
    "update:open",
    "cancel"
  ],
  data() {
    var t, e, i;
    return {
      focusTrap: null,
      opened: this.open,
      shortcutsDisabled: (i = (e = (t = window.OCP) == null ? void 0 : t.Accessibility) == null ? void 0 : e.disableKeyboardShortcuts) == null ? void 0 : i.call(e),
      triggerId: s(),
      descriptionId: s()
    };
  },
  computed: {
    wrapperTag() {
      return this.isNav ? "nav" : "div";
    },
    clickOutsideConfig() {
      return [
        this.closeMenu,
        this.clickOutsideOptions
      ];
    }
  },
  watch: {
    open(t) {
      t ? this.openMenu() : this.closeMenu();
    }
  },
  mounted() {
    document.addEventListener("keydown", this.onKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeyDown);
  },
  methods: {
    /**
     * Toggle the current menu open state
     */
    toggleMenu() {
      this.opened ? this.closeMenu() : this.openMenu();
    },
    /**
     * Close the current menu
     *
     * @param {boolean} cancelled emit a cancel event instead of close
     */
    closeMenu(t = !1) {
      this.opened = !1, this.$emit(t ? "cancel" : "close"), this.$emit("update:open", !1), this.clearFocusTrap(), this.$nextTick(() => {
        this.$emit("closed");
      });
    },
    /**
     * Open the current menu
     */
    openMenu() {
      this.opened = !0, this.$emit("open"), this.$emit("update:open", !0), this.$nextTick(() => {
        this.useFocusTrap(), this.$emit("opened");
      });
    },
    onKeyDown(t) {
      this.shortcutsDisabled || !this.opened || t.key === "Escape" && (t.preventDefault(), this.closeMenu(!0));
    },
    /**
     * Add focus trap for accessibility.
     * Shall only be used when all children are mounted
     * and available in the DOM. We use $nextTick for that.
     */
    async useFocusTrap() {
      if (this.focusTrap)
        return;
      const t = this.$refs.content;
      this.focusTrap = o(t, {
        allowOutsideClick: !0,
        trapStack: c(),
        fallbackFocus: this.$refs.trigger
      }), this.focusTrap.activate();
    },
    clearFocusTrap() {
      var t;
      (t = this.focusTrap) == null || t.deactivate(), this.focusTrap = null;
    }
  }
};
var u = function() {
  var e = this, i = e._self._c;
  return i(e.wrapperTag, { directives: [{ name: "click-outside", rawName: "v-click-outside", value: e.clickOutsideConfig, expression: "clickOutsideConfig" }], tag: "component", staticClass: "header-menu", class: { "header-menu--opened": e.opened }, attrs: { id: e.id, "aria-labelledby": e.isNav ? e.triggerId : null } }, [i("button", { ref: "trigger", staticClass: "header-menu__trigger button-vue", attrs: { id: e.isNav ? e.triggerId : null, "aria-label": e.ariaLabel, "aria-describedby": e.description ? e.descriptionId : null, "aria-controls": `header-menu-${e.id}`, "aria-expanded": e.opened.toString() }, on: { click: function(r) {
    return r.preventDefault(), e.toggleMenu.apply(null, arguments);
  } } }, [e._t("trigger")], 2), e.description ? i("span", { staticClass: "header-menu__description hidden-visually", attrs: { id: e.descriptionId } }, [e._v(" " + e._s(e.description) + " ")]) : e._e(), i("div", { directives: [{ name: "show", rawName: "v-show", value: e.opened, expression: "opened" }], staticClass: "header-menu__carret" }), i("div", { directives: [{ name: "show", rawName: "v-show", value: e.opened, expression: "opened" }], staticClass: "header-menu__wrapper", attrs: { id: `header-menu-${e.id}` } }, [i("div", { ref: "content", staticClass: "header-menu__content" }, [e._t("default")], 2)])]);
}, l = [], m = /* @__PURE__ */ d(
  p,
  u,
  l,
  !1,
  null,
  "d93df21d",
  null,
  null
);
const I = m.exports;
export {
  I as default
};
